// Button Component
export default function Button(props) {
  return <button className="primBtn">{props.value}</button>;
}
